<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" v-loading="loading">
      <!-- 复查列表 strat -->
      <el-tab-pane label="验光检查档案" name="first">
        <div class="block">
          <el-button type="primary" @click="clicksearch">查询</el-button>
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="CreateTime" label="创建时间" width="200px"></el-table-column>
          <el-table-column prop="Yanguangriqi" label="验光日期" width="150px"></el-table-column>
          <el-table-column prop="Name" label="姓名" width="150px"></el-table-column>
          <el-table-column prop="Sex" label="性别" width="100px"></el-table-column>
          <el-table-column prop="Age" label="年龄" width="100px"></el-table-column>
          <el-table-column prop="Phone" label="手机" width="300px"></el-table-column>
          <el-table-column prop="operation" label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickModify(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 复查列表 end -->

      <el-tab-pane label="添加" name="four">
        <CustomerYanGuangJianChaSub ref="SubVuefour" v-on:triggerFunc="BackToFirst"></CustomerYanGuangJianChaSub>
      </el-tab-pane>

      <el-tab-pane label="修改" name="five" disabled>
        <CustomerYanGuangJianChaSub ref="SubVuefive" v-on:triggerFunc="BackToFirst"></CustomerYanGuangJianChaSub>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import CustomerYanGuangJianChaSub from '@/componentsSubVue/CustomerYanGuangJianChaSub.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    CustomerYanGuangJianChaSub
  },
  data () {
    return {
      activeName: 'first',
      loading: false,
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      glassuserid: 0
    }
  },
  mounted () {
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp7ShiGuangYanGuangJianChaNum()
      this.apiGetErp7ShiGuangYanGuangJianChaList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp7ShiGuangYanGuangJianChaNum()
      this.apiGetErp7ShiGuangYanGuangJianChaList()
    },
    LoadData (id) {
      this.dataList = []
      this.dataListnum = 0
      this.glassuserid = id
      this.apiGetErp7ShiGuangYanGuangJianChaNum()
      this.apiGetErp7ShiGuangYanGuangJianChaList()
      this.$refs.SubVuefour.initData(this.glassuserid)
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp7ShiGuangYanGuangJianChaList()
    },
    clickModify (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.editMode(row)
    },
    clickDelete (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp7ShiGuangYanGuangJianCha(row.Id)
      })
    },
    apiGetErp7ShiGuangYanGuangJianChaList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.glassuserid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp7ShiGuangYanGuangJianChaList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp7ShiGuangYanGuangJianChaNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp7ShiGuangYanGuangJianChaNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp7ShiGuangYanGuangJianCha: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp7ShiGuangYanGuangJianCha, Qs.stringify(data))
        .then(function (response) {
          that.apiGetErp7ShiGuangYanGuangJianChaNum()
          that.apiGetErp7ShiGuangYanGuangJianChaList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
